var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('UpperHeader'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('ScrollToTop'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }